import { render } from "./B2bTableMenuOrdersReceived.vue?vue&type=template&id=fe6fa56e&scoped=true&lang=pug"
import script from "./B2bTableMenuOrdersReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuOrdersReceived.vue?vue&type=script&lang=js"

import "./B2bTableMenuOrdersReceived.vue?vue&type=style&index=0&id=fe6fa56e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe6fa56e"]])

export default __exports__